const StaffSchedulingAttendance = {
  available: 'available',
  absent: 'absent',
}

export default StaffSchedulingAttendance
